(function() {
    'use strict';

    angular.module('stats')
        .directive('cpProductsStats', cpProductsStats);

    cpProductsStats.$inject = ['$state', 'productsStatsDataSrvc', 'clientStatsDataSrvc', 'dateFormatConst', 'momentSrvc', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'filterQuerySrvc', 'previewStatsSrvc'];

    function cpProductsStats($state, productsStatsDataSrvc, clientStatsDataSrvc, dateFormatConst, momentSrvc, datatableDefaultPageSizeValueConst, checkSearchSrvc, filterQuerySrvc, previewStatsSrvc) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/stats/directives/products-stats/products-stats.html',
            scope: {
                isDefault: '=',
                weeks: '=',
                months: '=',
                years: '=',
                shopVersion: '='
            },
            link: function(scope, element, attrs, controller) {
                var self = scope;

                self.loading = true;

                self.pageOpts = {
                    count: undefined,
                    page: 1,
                    pageSize: datatableDefaultPageSizeValueConst
                };
                self.dateRange = {daterangeFilter: {startDate: null, endDate: null}}
                self.shopVersionOptions = [];

                self.summaryCols = {
                    'no_orders': 'no_orders',
                    'net_value': 'net_value',
                    'weight': 'weight',
                    'no_logins': 'no_logins'
                }

                self.rows = [];
                self.cols = [{
                    title: 'Produkt',
                    value: 'name',
                    type: 'text',
                    searchable: true,
                    orderable: true,
                    type: 'text',
                }, {
                    title: 'ID Produktu',
                    value: 'id',
                    type: 'number',
                    orderable: true
                }, {
                    title: 'Ilość zamówień produktu',
                    value: 'no_orders',
                    type: 'number',
                }, {
                    title: 'Wartość netto',
                    value: 'net_value',
                    type: 'decimal'
                }, {
                    title: 'Waga',
                    value: 'weight',
                    type: 'decimal'
                }, {
                    title: 'Ilość loginów, które zamówiły produkt',
                    value: 'no_logins',
                    type: 'number'
                }];

                self.searchQuery = {
                    pk: null,
                    name: null,
                    ordering: null
                };

                self.dateFormat = dateFormatConst.defaultPythonDate;
                self.filterData = {
                    min_date: null,
                    max_date: null,
                    shop_version: null
                };

                self.pageChange = pageChange;
                self.onSearchQueryChange = onSearchQueryChange;
                self.changeFilter = changeFilter;

                activate();

                function activate() {
                    self.filterData = filterQuerySrvc.initializeFilterData(self.filterData);
                    self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
                    self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
                    getShopVersions();
                    filterQuerySrvc.setLocationParams();
                    var minDate = moment(self.filterData.min_date, 'DD.MM.YYYY');
                    var maxDate = moment(self.filterData.max_date, 'DD.MM.YYYY');
                    if (!scope.isDefault){
                        if (scope.weeks) {
                            minDate = minDate.subtract(scope.weeks, 'w')
                            maxDate = maxDate.subtract(scope.weeks, 'w')
                        }
                        if (scope.months) {
                            minDate = minDate.subtract(scope.months, 'M')
                            maxDate = maxDate.subtract(scope.months, 'M')
                        }
                        if (scope.years) {
                            minDate = minDate.subtract(scope.years, 'y')
                            maxDate = maxDate.subtract(scope.years, 'y')
                        }
                        self.filterData.min_date = minDate.format(dateFormatConst.backendDate);
                        self.filterData.max_date = maxDate.format(dateFormatConst.backendDate);;
                    }

                    if (self.filterData.min_date) {
                        self.dateRange.daterangeFilter['startDate'] = minDate;
                        self.dateRange.daterangeFilter['endDate'] = maxDate;
                    }
                    getStats();
                }

                function getShopVersions() {
                    clientStatsDataSrvc.shopVersions().$promise.then(
                        function(response) {
                            self.shopVersionOptions = response;
                        }
                    )
                }

                function getStats(filterObj) {
                    self.loading = true;

                    if (!filterObj) {
                        filterObj = {
                            page: self.pageOpts.page,
                            page_size: self.pageOpts.pageSize,

                            pk: self.searchQuery.pk,
                            name: self.searchQuery.name,
                            ordering: self.searchQuery.ordering,

                            min_date: self.filterData.min_date || null,
                            max_date: self.filterData.max_date || null,
                            shop_version: self.filterData.shop_version || null
                        }
                    }
                    productsStatsDataSrvc.list(filterObj)
                        .$promise
                        .then(
                            function (response) {
                                self.rows = response.results;
                                self.pageOpts.count = response.count;
                            },
                            function (response) {
                                if (response.status === 404 && filterObj.page !== 1) {
                                    checkSearchSrvc.recall(filterObj, getStats);
                                }
                            }
                        )
                        .finally(
                            function(response) {
                                self.loading = false;
                                return response;
                            }
                        );
                }

                function pageChange() {
                    filterQuerySrvc.updatePageOpts(self.pageOpts);
                    filterQuerySrvc.setLocationParams();
                    getStats();
                }

                function onSearchQueryChange() {
                    filterQuerySrvc.updateSearchQuery(self.searchQuery);
                    filterQuerySrvc.setLocationParams();
                    getStats();
                }

                function changeFilter() {
                    if (self.dateRange.daterangeFilter.startDate) {
                        self.filterData.min_date = self.dateRange.daterangeFilter.startDate.format(dateFormatConst.backendDate);
                        self.filterData.max_date = self.dateRange.daterangeFilter.endDate.format(dateFormatConst.backendDate)
                    } else {
                        self.filterData.min_date = null;
                        self.filterData.max_date = null;
                    }
                    if (scope.isDefault) {
                        filterQuerySrvc.updateFilterData(self.filterData);
                        filterQuerySrvc.setLocationParams();
                    }
                    getStats();
                }
            }
        };
    }
})();
